import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Card, Grid, Icon, Text } from "~/components-shared";
import { useDispatch } from "react-redux";
import styled, { useTheme } from "styled-components";
import progressFlowActionCreators from "~/store/progressFlow/actions";
import { ProgressFlowActionEnum } from "~/store/progressFlow/types";
import { AuthoritiesEnum } from "~/types/enums";
import useAbacExt from "~/hooks/abac";
const FixedCard = styled(Card)`
  position: sticky;
  bottom: 1em;
  z-index: 2;
  width: initial;
`;
const StyledGrid = styled(Grid)`
  border-left: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};
  border-right: 1px solid ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.borders.primary;
}};
`;
const ProgressFlowSelectionCard = _ref3 => {
  let {
    selection,
    setSelection
  } = _ref3;
  const {
    colors
  } = useTheme();
  const {
    t
  } = useTranslation();
  const dispatch = useDispatch();
  const {
    userHas
  } = useAbacExt();
  const deleteProgressFlowItems = () => {
    dispatch(progressFlowActionCreators.actionChanged(ProgressFlowActionEnum.BULK_DELETE, null, {
      progressFlowItems: selection || [],
      count: selection.length
    }));
  };
  const dismissProgressFlowItems = () => {
    dispatch(progressFlowActionCreators.actionChanged(ProgressFlowActionEnum.BULK_DISMISS, null, {
      progressFlowItems: selection || [],
      count: selection.length
    }));
  };
  const markAsDoneProgressFlowItems = () => {
    dispatch(progressFlowActionCreators.actionChanged(ProgressFlowActionEnum.BULK_MARK_AS_DONE, null, {
      progressFlowItems: selection || [],
      count: selection.length
    }));
  };
  const markAsNotDoneProgressFlowItems = () => {
    dispatch(progressFlowActionCreators.actionChanged(ProgressFlowActionEnum.BULK_MARK_AS_NOT_DONE, null, {
      progressFlowItems: selection || [],
      count: selection.length
    }));
  };
  const moveProgressFlowItems = () => {
    dispatch(progressFlowActionCreators.actionChanged(ProgressFlowActionEnum.BULK_MOVE, null, {
      progressFlowItems: selection,
      count: selection.length
    }));
  };
  return /*#__PURE__*/React.createElement(FixedCard, {
    s: {
      p: 2
    },
    border: true,
    color: colors.background.secondary,
    align: "left",
    maxWidth: `${userHas(AuthoritiesEnum.EXPERIMENTAL) ? "28rem" : "23rem"}`
  }, /*#__PURE__*/React.createElement(Grid, {
    cols: userHas(AuthoritiesEnum.EXPERIMENTAL) ? 7 : 5,
    gap: 1,
    template: `${userHas(AuthoritiesEnum.EXPERIMENTAL) ? "auto auto auto auto 1fr auto" : "auto auto 1fr auto"}`,
    align: "center",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: dismissProgressFlowItems,
    color: "transparent",
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.dismissItems", {
      count: selection.length
    }),
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "cross"
  })), /*#__PURE__*/React.createElement(StyledGrid, {
    cols: 2,
    gap: 1,
    s: {
      px: 1
    }
  }, /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.markAsDoneItems", {
      count: selection.length
    }),
    onClick: markAsDoneProgressFlowItems,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "tick",
    color: "primary"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.markAsNotDoneItems", {
      count: selection.length
    }),
    onClick: markAsNotDoneProgressFlowItems,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "refresh"
  }))), userHas(AuthoritiesEnum.EXPERIMENTAL) && /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.deleteItems", {
      count: selection.length
    }),
    onClick: deleteProgressFlowItems,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "bin",
    color: "danger"
  })), userHas(AuthoritiesEnum.EXPERIMENTAL) && /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.moveItems", {
      count: selection.length
    }),
    onClick: moveProgressFlowItems,
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "move"
  })), /*#__PURE__*/React.createElement(Text, {
    color: "textSecondary",
    s: {
      pl: userHas(AuthoritiesEnum.EXPERIMENTAL) ? 0 : 2
    }
  }, t("ProgressFlowSelectionCard.selected", {
    count: selection.length
  })), /*#__PURE__*/React.createElement(Button, {
    "data-tooltip-id": "general-tooltip",
    "data-tooltip-content": t("ProgressFlowSelectionCard.cancelSelection"),
    onClick: () => setSelection([], true),
    color: "transparent",
    outline: false,
    s: {
      p: 2
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    scale: 5,
    src: "cross"
  }))));
};
export default ProgressFlowSelectionCard;